<template>
  <div class="aboutCard">
    <div class="title-wrap">
      <h1 class="title">{{ title }}</h1>
      <p>{{ pTag }}</p>
    </div>
    <img :src="require('@/assets/' + imageName + '')" :alt="altTag" />
  </div>
</template>

<script>
export default {
  name: "aboutCard",
  props: {
    title: String,
    pTag: String,
    imageName: String,
    altTag: String,
  },
};
</script>

<style scoped>
img {
  display: inline-block;
  vertical-align: middle;
  height: 250px;
}

.title-wrap h1 {
  font-size: 2em;
  font-family: Montserrat-Light;
  font-weight: 100;
  width: 70%;
}

.title-wrap p {
  transform: translateX(30%);
  width: 90%;
}

.title-wrap {
  width: 30%;
  display: inline-block;
  vertical-align: middle;
}
</style>
